import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

import { DEFAULT_NETNDP_QBR } from 'partner360/models/actualValueTypes'
import { QBRRounding } from 'partner360/models/qbr/QBRRounding'

import { IQBRDocumentDetail } from '../../models/qbr/IQBRDocumentDetail'
import { ISlideSection } from '../../models/qbr/ISlideSection'

import { IDocumentSettings, IQBRState } from './models/state'

export const DEFAULT_CURRENCY = 'USD'
export const DEFAULT_FYEAR = 2024
export const DEFAULT_FQUARTER = 1
export const DEFAULT_ROUNDING = QBRRounding.AsIs

export const DEFAULT_SLIDES = []
export const DEFAULT_ELT_VERSION = ''

export const DEFAULT_IS_GLOBAL_PLANS = 1

export enum SlidesSectionKeys {
  QbrPlanAtGlance = 'qbr-plan-at-glance',
  QbrPlanAtGlanceUnits = 'qbr-plan-at-glance-units',
  QbrPlanAchievement = 'qbr-plan-achievement',
  QbrPlanAchievementCharts = 'qbr-plan-achievement-charts',
  QbrSobAchievement = 'qbr-hp-sob-achievement',
  QbrSobAchievementCharts = 'qbr-hp-sob-achievement-charts',
  QbrInitiatives = 'qbr-initiatives',
  QbrSobCompetitors = 'qbr-sob-competitors',

  EltMeetingLogistics = 'elt-meeting-logistics',
  EltStoryBehindTheAccount = 'elt-story-behind-the-account',
  EltPerformanceAtThisAccount = 'elt-performance-at-this-account',
  EltAccountFinancials = 'elt-account-financials',
  EltPolyBreakoutFinancials = 'elt-poly-breakout-financials',
  EltMeetingObjective = 'elt-meeting-objective',
  EltUpdatesFromLastMeeting = 'elt-updates-from-last-meeting',
  EltPlcScorecard = 'elt-plc-scorecard',
}
export const DEFAULT_SLIDES_SECTIONS: ISlideSection[] = [
  { Type: 'qbr', Order: 110, Key: SlidesSectionKeys.QbrPlanAtGlance, IsSelected: 1 },
  { Type: 'qbr', Order: 120, Key: SlidesSectionKeys.QbrPlanAtGlanceUnits, IsSelected: 1 },
  { Type: 'qbr', Order: 130, Key: SlidesSectionKeys.QbrPlanAchievement, IsSelected: 1 },
  { Type: 'qbr', Order: 140, Key: SlidesSectionKeys.QbrPlanAchievementCharts, IsSelected: 1 },
  { Type: 'qbr', Order: 150, Key: SlidesSectionKeys.QbrSobAchievement, IsSelected: 1 },
  { Type: 'qbr', Order: 160, Key: SlidesSectionKeys.QbrSobAchievementCharts, IsSelected: 1 },
  { Type: 'qbr', Order: 170, Key: SlidesSectionKeys.QbrInitiatives, IsSelected: 1 },
  { Type: 'qbr', Order: 180, Key: SlidesSectionKeys.QbrSobCompetitors, IsSelected: 1 },

  { Type: 'elt', Order: 210, Key: SlidesSectionKeys.EltMeetingLogistics, IsSelected: 1 },
  { Type: 'elt', Order: 220, Key: SlidesSectionKeys.EltStoryBehindTheAccount, IsSelected: 1 },
  { Type: 'elt', Order: 230, Key: SlidesSectionKeys.EltPerformanceAtThisAccount, IsSelected: 1 },
  { Type: 'elt', Order: 240, Key: SlidesSectionKeys.EltAccountFinancials, IsSelected: 1 },
  { Type: 'elt', Order: 250, Key: SlidesSectionKeys.EltPolyBreakoutFinancials, IsSelected: 1 },
  { Type: 'elt', Order: 260, Key: SlidesSectionKeys.EltMeetingObjective, IsSelected: 1 },
  { Type: 'elt', Order: 270, Key: SlidesSectionKeys.EltUpdatesFromLastMeeting, IsSelected: 1 },
  { Type: 'elt', Order: 280, Key: SlidesSectionKeys.EltPlcScorecard, IsSelected: 1 },
]

export const defaultDocumentSettings: IDocumentSettings = {
  currency: DEFAULT_CURRENCY,
  netNdp: DEFAULT_NETNDP_QBR,
  rounding: DEFAULT_ROUNDING,
  offerings: [],
  netNdpOptions: [],
  currencyOptions: [],
  selectedPeriod: {
    fYear: DEFAULT_FYEAR,
    fQuarters: [
      {
        fQuarter: DEFAULT_FQUARTER,
      },
    ],
  },
  periodOptions: [
    {
      fYear: DEFAULT_FYEAR,
      isEnabled: true,
      fQuarters: [
        {
          fQuarter: DEFAULT_FQUARTER,
          isEnabled: true,
        },
      ],
    },
  ],
  currentFYear: DEFAULT_FYEAR,
  currentFQuarter: DEFAULT_FQUARTER,
  exportSlides: DEFAULT_SLIDES,
  eltVersion: DEFAULT_ELT_VERSION,
  isGlobalPlans: undefined,
}

export const defaultDocument: IQBRDocumentDetail = {
  PlanAchievement: [],
  SobAchievement: [],
  SobCompetitors: {},
  SobCompetitorsComments: {},
  KeyPoints: [],
  KeyInitiatives: [],
  DocumentGeneratedDateQuarterPercent: 0,
  DocumentGeneratedUpToDate: 0,
  DocumentHideUtD: 0,
  DocumentGeneratedDate: '',
  DocumentGeneratedDateYearPercent: 0,
  EmptyOfferings: [],
}

export const initialState: IQBRState = {
  entryId: null,
  rtm: PartnerType.Distributor,
  name: '',
  userRole: '',
  selectedDocument: null,
  documentSettings: defaultDocumentSettings,
  documentPartners: [],
  fYear: DEFAULT_FYEAR,
  fQuarter: DEFAULT_FQUARTER,
  lastStep: 1,
  isSelectedDocumentChanged: false,
  isLegacyDocument: false,
  lastModified: null,
  pptxReportState: {
    uid: null,
    pptxReport: null,
    isGenerating: false,
    error: null,
  },
  error: null,
  isApplyingChanges: false,
  unpopulatedFieldsMessages: [],
  isFinalized: false,
  dnaLoadDate: null,
  globalPartnerId: null,
  documentPartnerName: null,
}
